var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightSkew = function SvgArrowRightSkew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    d: "M25.192 12.465a1 1 0 1 1 1.415-1.414 1 1 0 0 1-1.415 1.414M13.879 18.122a1 1 0 1 1 1.414-1.414 1 1 0 0 1-1.414 1.414M16.707 15.293a1 1 0 1 1 1.414-1.414 1 1 0 0 1-1.414 1.414M19.536 12.465a1 1 0 1 1 1.413-1.414 1 1 0 0 1-1.413 1.414M22.364 9.636a1 1 0 1 1 1.414-1.414 1 1 0 0 1-1.414 1.414M25.192 6.808a1 1 0 1 1 1.415-1.414 1 1 0 0 1-1.415 1.414M19.536 6.808a1 1 0 1 1 1.413-1.414 1 1 0 0 1-1.413 1.414M5.393 26.607a1 1 0 1 1 1.415-1.414 1 1 0 0 1-1.415 1.414M13.879 6.808a1 1 0 1 1 1.414-1.414 1 1 0 0 1-1.414 1.414M25.192 18.122a1 1 0 1 1 1.415-1.414 1 1 0 0 1-1.415 1.414"
  })));
};
export default SvgArrowRightSkew;